module.exports = "<div class=\"box-container\">\n    <div class=\"box shadow center-block\">\n\n        <div class=\"full-height\" [class.hidden-xs]=\"adaptive\">\n            <ng-content select=\"page-base-tile-content\"></ng-content>\n        </div>\n\n        <div class=\"full-height\" [class.visible-xs]=\"adaptive\" [class.invisible]=\"!adaptive\">\n            <ng-content select=\"page-base-tile-content-mobile\"></ng-content>\n        </div>\n\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/partials/pagebasetile/component.html
// module id = 907
// module chunks = 0